// 资金流水表格列定义
export const tableColumns = [
  {
    key: 'orderNo',
    title: '业务订单ID',
    width: 260,
    scopedSlots: { customRender: 'orderNoSlot' }
  },
  {
    key: 'balanceBefore',
    title: '变更前金额',
    width: 200,
    scopedSlots: { customRender: 'balanceBeforeSlot' },
    sorter: (a, b) => a.balanceBefore - b.balanceBefore
  },
  {
    key: 'transactionAmount',
    title: '变更金额',
    width: 200,
    scopedSlots: { customRender: 'transactionAmountSlot' },
    sorter: (a, b) => a.transactionAmount - b.transactionAmount
  },
  {
    key: 'balanceAfter',
    title: '变更后余额',
    width: 200,
    scopedSlots: { customRender: 'balanceAfterSlot' },
    sorter: (a, b) => a.balanceAfter - b.balanceAfter
  },
  {
    key: 'fee',
    title: '手续费',
    width: 120,
    scopedSlots: { customRender: 'feeSlot' },
    sorter: (a, b) => a.fee - b.fee
  },
  {
    key: 'transactionCategory',
    title: '业务类型',
    width: 120,
    scopedSlots: { customRender: 'transactionCategorySlot' }
  },
  {
    key: 'transactionTime',
    title: '变更时间',
    width: 260,
    // dataIndex: 'orderTime'
    scopedSlots: { customRender: 'transactionTimeSlot' },
    sorter: (a, b) => a.transactionTime - b.transactionTime
  },
  {
    key: 'remark',
    title: '备注',
    minWidth: 300,
    scopedSlots: { customRender: 'remarkSlot' }
  }
]
